import { QUERY_KEYS } from 'api/query-keys';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { sharedPaymentService } from 'api/services';
import { Site } from 'shared/hooks';
import { PaymentUsersFilters } from './use-payment-users.types';

type UnblockUserMutationContext = { site: Site; flexWorkerId: string };
type UnblockUserMutationOptions = UseMutationOptions<unknown, Error, UnblockUserMutationContext>;

export const useUnblockUser = (
  appliedFilters: PaymentUsersFilters,
  options?: UnblockUserMutationOptions
) => {
  const mutationFn = async ({ site, flexWorkerId }: UnblockUserMutationContext) =>
    await sharedPaymentService.unblockUser(site, flexWorkerId);
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};

  return useMutation(mutationFn, {
    onSuccess: async (data, variables, context) => {
      queryClient.invalidateQueries(QUERY_KEYS.paymentUsers(appliedFilters));
      onSuccess && onSuccess(data, variables, context);
    },
    ...restOptions,
  });
};
